import { action, computed, makeObservable, observable } from 'mobx';
import toast from 'react-hot-toast';
import URLConstants from '../../constants/url-constants';
import config from '../../helpers/config-helper';
import {
  IAddProcessTemplate,
  IProcessOptions,
  IUpdateProcessTemplate,
} from '../../models/forms/IAddUpdateProcessTemplate';
import { IOption } from '../../models/ICommon';
import IApiResponse, {
  IApiSuccessResponse,
} from '../../models/response/IApiResponse';
import {
  IBaseProcessTemplateListVM,
  IProcessTemplateList,
  IProcessTemplateListVM,
  IProcessTemplateVM,
} from '../../models/response/IProcessTemplateResponse';
import { IProcessTemplateState } from '../../models/state/IProcessTemplateState';
import { formatMessage } from '../../translations/format-message';
import {
  AddProcessTemplateInitalState,
  GetAllProcessTemplateState,
  GetAllProcessTemplateStateNew,
  ObservableInitialState,
} from '../initialState';
import * as baseService from '../service/base-service';
const appConfig = config();

export class ProcessTemplateStore implements IProcessTemplateState {
  initialStateValue = ObservableInitialState;
  processTemplateList: IProcessTemplateListVM = GetAllProcessTemplateState;
  processTemplateListNew: IBaseProcessTemplateListVM =
    GetAllProcessTemplateStateNew;
  processTemplate: IAddProcessTemplate | undefined = undefined;
  processTemplateById: IProcessTemplateVM | undefined = undefined;
  processTemplateState = { ...this.initialStateValue };
  addUpdateProcessTemplateState = { ...this.initialStateValue };
  deleteProcessTemplateState = { ...this.initialStateValue };
  getAllProcessTemplateState = { ...this.initialStateValue };
  getAllTemplateState = { ...this.initialStateValue };

  constructor() {
    makeObservable(this, {
      processTemplate: observable,
      processTemplateState: observable,
      processTemplateList: observable,
      addUpdateProcessTemplateState: observable,
      deleteProcessTemplateState: observable,
      getAllProcessTemplateState: observable,
      GetProcessTemplateListService: action,
      GetProcessTemplateByIdService: action,
      AddProcessTemplateService: action,
      UpdateProcessTemplateService: action,
      DeleteProcessTemplateService: action,
      resetDeleteProcessTemplate: action,
      resetAddUpdateProcessTemplateState: action,
      reset: action,
      allProcessTemplate: computed,
      processTemplateDetails: computed,
      getAllTemplateState: observable,
      resetGetAllTemplateState: action,
      productProcessTemplates: computed,
      resetProcessTemplateDetail: action,
      resetStore: action,
    });
  }

  //#region Actions
  GetProcessTemplateListService = (
    tenantId: number,
    currentPage: number,
    pagerSize: number
  ) => {
    this.getAllProcessTemplateState.inProgress = true;
    const url =
      URLConstants.GetProcessTemplateList +
      '?TenantId=' +
      tenantId +
      '&PageSize=' +
      pagerSize +
      '&PageNo=' +
      currentPage;
    return baseService
      .getRequest(url)
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<IProcessTemplateListVM>>
        ) => {
          if (response.data.Error) {
            this.getAllProcessTemplateState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.processTemplateList = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.getAllProcessTemplateState.error = err;
      })
      .finally(
        action(() => {
          this.getAllProcessTemplateState.inProgress = false;
        })
      );
  };

  AddProcessTemplateService = (data: IAddProcessTemplate) => {
    this.addUpdateProcessTemplateState.inProgress = true;
    const url = URLConstants.AddProcessTemplate;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateProcessTemplateState.error = response.data.Message;
        } else {
          this.addUpdateProcessTemplateState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateProcessTemplateState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateProcessTemplateState.inProgress = false;
        })
      );
  };

  UpdateProcessTemplateService = (data: IUpdateProcessTemplate) => {
    this.addUpdateProcessTemplateState.inProgress = true;
    let url = URLConstants.UpdateProcessTemplate;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateProcessTemplateState.error = response.data.Message;
        } else {
          this.addUpdateProcessTemplateState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateProcessTemplateState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateProcessTemplateState.inProgress = false;
        })
      );
  };

  GetProcessTemplateByIdService = (tenantId: number, templateId: number) => {
    this.processTemplateState.inProgress = true;
    let url =
      URLConstants.GetTemplateById +
      '?TenantId=' +
      tenantId +
      '&TemplateId=' +
      templateId;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IAddProcessTemplate>>) => {
          if (response.data.Error) {
            this.processTemplateState.error = response.data.Message;
          } else {
            this.processTemplate = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.processTemplateState.error = err;
      })
      .finally(
        action(() => {
          this.processTemplateState.inProgress = false;
        })
      );
  };

  DeleteProcessTemplateService = (tenantId: number, templateId: number) => {
    this.deleteProcessTemplateState.inProgress = true;
    const url =
      URLConstants.DeleteProcessTemplate +
      '?TenantId=' +
      tenantId +
      '&Id=' +
      templateId;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteProcessTemplateState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteProcessTemplateState.success = true;
      })
      .catch((err: string) => {
        this.deleteProcessTemplateState.error = err;
      })
      .finally(
        action(() => {
          this.deleteProcessTemplateState.inProgress = false;
        })
      );
  };

  GetAllTemplatesService = (tenantId: number) => {
    this.getAllTemplateState.inProgress = true;
    const url = `${URLConstants.GetAllProcessTemplates}?TenantId=${tenantId}`;

    return baseService
      .getRequest(url)
      .then(
        (
          response: IApiResponse<
            IApiSuccessResponse<IBaseProcessTemplateListVM>
          >
        ) => {
          if (response.data.Error) {
            this.getAllTemplateState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.processTemplateListNew = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.getAllTemplateState.error = err;
      })
      .finally(
        action(() => {
          this.getAllTemplateState.inProgress = false;
        })
      );
  };
  //#endregion

  //#region Computed
  get allProcessTemplate(): IProcessTemplateList[] {
    let processTemplateData: IProcessTemplateList[] = [];
    if (
      this.processTemplateList?.processTemplates &&
      this.processTemplateList.processTemplates?.length > 0
    ) {
      this.processTemplateList.processTemplates.map((processTemplate) => {
        processTemplateData.push({
          Id: processTemplate.Id,
          TemplateName: processTemplate.TemplateName,
          Remarks: processTemplate.Remarks || ' ',
        });
      });
    }
    return processTemplateData;
  }

  get processTemplateDetails(): IAddProcessTemplate {
    if (this.processTemplate) {
      return {
        Id: this.processTemplate.Id,
        TenantId: this.processTemplate.TenantId,
        TemplateName: this.processTemplate.TemplateName,
        Remarks: this.processTemplate.Remarks,
        ProcesTemplates: this.processTemplate.ProcesTemplates,
      };
    }

    return AddProcessTemplateInitalState;
  }

  get productProcessTemplates(): IProcessOptions[] {
    let templates = [];
    if (this.processTemplate) {
      templates = this.processTemplate.ProcesTemplates?.length > 0 ? [
        {
          Id: -1,
          ProcessId: -1,
          DueDates: this.processTemplate.ProcesTemplates[0].DueDates,
          ProcessOrder: 0,
          ProcessName: 'Tag Allocation',
          Type: -1,
          ShortName: 'ALLOCATE',
        },
        ...this.processTemplate.ProcesTemplates,
        {
          Id: -1,
          ProcessId: -2,
          // DueDates:
          //   this.processTemplate.ProcesTemplates[
          //     this.processTemplate.ProcesTemplates.length - 1
          //   ].DueDates,
          DueDates: 0,
          ProcessOrder: 0,
          ProcessName: 'Tag Remove',
          Type: -2,
          ShortName: 'REMOVE',
        },
      ] : [];
      return templates;
    }

    return templates;
  }

  get allAvailableProcessTemplates(): IOption[] {
    const processTemplates: IOption[] = [
      {
        id: -1,
        value: 'please_select',
        disabled: false,
      },
    ];
    if (
      this.processTemplateListNew?.processTemplates &&
      this.processTemplateListNew.processTemplates?.length > 0
    ) {
      this.processTemplateListNew.processTemplates.map((process) => {
        processTemplates.push({
          id: process.Id,
          value: process.TemplateName,
          disabled: false,
        });
      });
    }

    return processTemplates;
  }
  //#endregion

  //#region Reset
  reset = () => {
    this.processTemplateList = GetAllProcessTemplateState;
  };

  resetProcessTemplateDetail = () => {
    this.processTemplate = undefined;
    this.processTemplateState = { ...this.initialStateValue };
  };

  resetDeleteProcessTemplate = () => {
    this.deleteProcessTemplateState = { ...this.initialStateValue };
  };

  resetAddUpdateProcessTemplateState = () => {
    this.addUpdateProcessTemplateState.inProgress = false;
    this.addUpdateProcessTemplateState.success = false;
    this.addUpdateProcessTemplateState.error = '';
  };

  resetGetAllTemplateState = () => {
    this.getAllTemplateState = { ...this.initialStateValue };
  };

  /**
   * This function is used to reset all store observables to their initial values.
   * @returns
   */
  resetStore = () => {
    this.processTemplate = undefined;
    this.processTemplateState = { ...this.initialStateValue };
    this.processTemplateList = GetAllProcessTemplateState;
    this.addUpdateProcessTemplateState = { ...this.initialStateValue };
    this.deleteProcessTemplateState = { ...this.initialStateValue };
    this.getAllProcessTemplateState = { ...this.initialStateValue };
    this.getAllTemplateState = { ...this.initialStateValue };
  };
  //#endregion
}

export default new ProcessTemplateStore();
